import createReducer from '../../../lib/createReducer';
import * as types from '../Actions/types';

export const initialState = {
    loading: false,
    validData: false,
    patientData: false,
    userData: false,
    verifyData: false,
    validateUser: false,
    userVerifyData: {},
    validDataFailed: {},
    apiFailed: {}
}

export const registerReducer = createReducer(initialState, {
    [types.VALIDATION_USERNAME_REQUEST](state, action) {
        return {
            ...state,
            payload: action.payload
        }
    },
    [types.VALIDATION_USERNAME_RESPONSE](state, action) {
        return {
            ...state,
            validData: action.response
        }
    },
    [types.VALIDATION_USERNAME_FAILED](state, action) {
        return {
            ...state,
            validDataFailed: action.response
        }
    },
    [types.CHECK_PATIENT_EXISTS_REQUEST](state, action) {
        return {
            ...state,
            payload: action.payload
        }
    },
    [types.CHECK_PATIENT_EXISTS_RESPONSE](state, action) {
        return {
            ...state,
            patientData: action.response
        }
    },
    [types.CHECK_PATIENT_EXISTS_FAILED](state, action) {
        return {
            ...state,
            patientData: false
        }
    },
    [types.SAVE_USERNAME](state, action) {
        return {
            ...state,
            userData: action.response
        }
    },
    [types.VERIFY_2FACODE_REQUEST](state, action) {
        return {
            ...state,
            payload: action.payload
        }
    },
    [types.VERIFY_2FACODE_RESPONSE](state, action) {
        return {
            ...state,
            verifyData: action.response
        }
    },
    [types.VERIFY_2FACODE_FAILED](state, action) {
        return {
            ...state,
            verifyData: false
        }
    },
    [types.VERIFY_CODE_RESPONSE](state, action) {
        return {
            ...state,
            userVerifyData: action.response
        }
    },
    [types.VALIDATE_PATIENT_EMAIL_PHONE](state, action) {
        return {
            ...state,
            payload: action.payload,
            token: action.token,
        };
    },
    [types.VALIDATE_PATIENT_EMAIL_PHONE_RESPONSE](state, action) {
        return {
            ...state,
            validateUser: action.response
        };
    },
    [types.REGISTER_REQUEST](state, action) {
        return {
            ...state,
            payload: action.payload,
            token: action.token,
        };
    },
    [types.ERROR_OCCURED](state, action) {
        return {
            ...state,
            apiFailed: action.response
        };
    },
    [types.ENABLE_LOADER](state) {
        return {
            ...state,
            loading: true,
        };
    },
    [types.DISABLE_LOADER](state) {
        return {
            ...state,
            loading: false,
        };
    },
    [types.RESET_REGISTER_DATA](state) {
        return {
            loading: false,
            validData: false,
            patientData: false,
            userData: false,
            verifyData: false,
            validateUser: false,
            userVerifyData: {}
        }
    }
});